<template>
  <a-modal
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :visible="visible"
    :title="modalTitle"
    :destroyOnClose="destroyOnClose"
    @ok="submitForm"
    @cancel="handleCancel"
  >
    <CardEdit
      ref="form"
      :source-data="sourceData"
      :schema="CREATE_SCHEMA"
      layout="horizontal"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      :defaultColXs="defaultColXs"
      :defaultColSm="defaultColSm"
      :defaultColMd="defaultColMd"
      :defaultColLg="defaultColLg"
      :defaultColXl="defaultColXl"
    >
      <template v-slot:menuList="">
        <a-cascader
          :options="sourceData.pids"
          :fieldNames="fieldNames"
          placeholder="请选择"
          change-on-select
          v-decorator="
            $decorator('pids', '', [{ required: false }], {
              initialValue: defaultValue,
            })
          "
        />
      </template>
    </CardEdit>
  </a-modal>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'
import CREATE_SCHEMA from '../schema'
import { addMenu, getMenuList } from '../api'
import { mapMutations } from 'vuex'
import { SET_MENUS } from 'config/mutation-types/user'
import { mapGetters } from 'vuex'
export default {
  components: {
    CardEdit,
  },
  data() {
    return {
      modalTitle: '新增角色',
      visible: false,
      confirmLoading: false,
      CREATE_SCHEMA,
      sourceData: {
        pid: '',
        pids: [],
        icon: '',
        name: '',
        url: '',
        order: '',
        code: '',
        index: '',
        display: '',
        id: '',
      },
      defaultColXs: 24,
      defaultColLg: 24,
      defaultColSm: 24,
      defaultColMd: 24,
      defaultColXl: 24,
      formLayout: 'horizontal',
      labelCol: {
        xs: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 16 },
      },
      fieldNames: { label: 'name', value: 'id', children: 'children' },
      destroyOnClose: true,
      defaultValue: [],
    }
  },
  computed: {
    ...mapGetters('user', ['menuUrlName']),
  },
  methods: {
    ...mapMutations('user', [SET_MENUS]),
    // 权限配置Tree树-请求数据
    _getMenuList() {
      getMenuList().then(({ data }) => {
        this.sourceData.pids = data
      })
    },
    // 新增
    add() {
      this.modalTitle = '新增菜单'
      this._getMenuList()
      this.visible = true
      this.defaultValue = []
      // 初始化数据
      for (let key in this.sourceData) {
        if (typeof this.sourceData[key] == 'object') {
          this.sourceData[key] = []
        } else {
          this.sourceData[key] = ''
        }
      }
    },
    // 编辑
    async edit(tableRow) {
      this.modalTitle = '编辑菜单'
      this._getMenuList()
      this.visible = true
      this.$nextTick(() => {
        const { pids } = tableRow
        for (let key in this.sourceData) {
          if (key === 'pids') {
            if (tableRow[key].length !== 0) {
              this.sourceData.pid = pids[pids.length - 1]
              this.defaultValue = JSON.parse(pids)
            } else {
              this.sourceData.pids = []
              this.sourceData.pid = ''
            }
          } else {
            this.sourceData[key] = tableRow[key]
          }
        }
      })
    },
    // 取消
    handleCancel() {
      this.visible = false
    },
    // 校验数据
    async validateForm() {
      const values = await this.$refs.form.handleSubmit()
      const passed = !!values
      if (passed) {
        const { pids } = values
        let query = values
        query.id = this.sourceData.id
        if (pids.length !== 0) {
          query.pid = pids[pids.length - 1]
          query.pids = JSON.stringify(pids)
        } else {
          query.pid = ''
          query.pids = '[]'
        }
        return query
      }
    },
    // 新增|维护 -接口
    async submitForm() {
      const query = await this.validateForm()
      if (query) {
        addMenu(query).then(({ data }) => {
          this[SET_MENUS](data)
          this.$message.success('添加成功')
          this.visible = false
          this.$emit('getTableList')
          this._getMenuList()
        })
      }
    },
  },
}
</script>
